var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1570(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 72,
    fill: "#B1A8A8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5557 51.0928C77.1161 42.5324 77.1161 28.6532 68.5557 20.0928C59.9953 11.5324 46.1161 11.5324 37.5557 20.0928C28.9953 28.6532 28.9953 42.5324 37.5557 51.0928C46.1161 59.6533 59.9953 59.6532 68.5557 51.0928Z",
    fill: "#E60020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1302 44.9659L44.4115 40.2794L39.7251 44.9659L37.6553 42.9283L42.3739 38.2097L37.6553 33.491L39.7251 31.4212L44.4115 36.1399L49.1302 31.4212L51.2 33.491L46.4813 38.2097L51.2 42.9283L49.1302 44.9659Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0766 47.1966V44.2528L63.9349 33.491C64.3638 32.9548 64.6802 32.4508 64.8732 31.9896C65.0663 31.5285 65.1628 31.003 65.1628 30.4239C65.1628 29.389 64.8732 28.5472 64.2888 27.9037C63.7043 27.2549 62.8785 26.9332 61.8007 26.9332C61.3718 26.9332 60.9482 26.9975 60.5406 27.1262C60.1331 27.2549 59.7685 27.4586 59.4575 27.7428C59.1465 28.0217 58.8945 28.3917 58.6961 28.8421C58.503 29.2925 58.4065 29.8448 58.4065 30.4882H55.1088C55.1088 29.5177 55.275 28.6276 55.6075 27.8233C55.94 27.0136 56.4065 26.3326 56.9963 25.7696C57.5861 25.2119 58.2939 24.7722 59.1143 24.4612C59.9347 24.1502 60.8248 23.9947 61.7954 23.9947C62.7659 23.9947 63.6936 24.1449 64.5086 24.4451C65.329 24.7454 66.0261 25.1797 66.6105 25.7374C67.195 26.3004 67.6454 26.9761 67.9672 27.775C68.2889 28.574 68.4497 29.4694 68.4497 30.4561C68.4497 31.4427 68.2674 32.3382 67.9028 33.0567C67.5382 33.7806 66.9966 34.5688 66.2888 35.4321L59.0821 44.2581H68.4551V47.2019H55.0713L55.0766 47.1966Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1570);
export default __webpack_public_path__ + "static/media/1570.365cd22635627dd7a1da2d7d376ee977.svg";
export { ForwardRef as ReactComponent };